module.exports = __webpack_public_path__ + "img/mongols-DE.4dc77e54.png";